import { Navigate } from "react-router-dom";
import { useUser } from "./useUser";

/**
 * Wraps a route gated by a per-user flag on the token rather than by a role.
 *
 * Anyone signed in before the flag existed has no such claim, so they are sent
 * to the unauthorized page until they sign in again — the safe way round.
 */
export const PermissionRoute = ({ permission, children }) => {
  const user = useUser();

  if (!user) return <Navigate to="/login" />;
  if (!user.isSuperadmin && user[permission] !== true) {
    return <Navigate to="/unauthorized" />;
  }
  return children;
};
